export default "dist/images/components-icon-controls-shaped.bd63950.png";